export default __webpack_public_path__ + "static/logo-white-9def96e9674da89bca399d16fb02a9c4.svg";